import pointFinger from '../../images/icons/touch_icon.svg';
import closeSvg from '../../images/icons/close.svg';
import { config } from '../../../config/config';
import { World } from '../../../World';

/**
 * @module QuickSettings
 */
(function () {
  let nextID = 0;

  function getNextID () {
    nextID++;
    return 'qs_' + nextID;
  }

  function createLabel (title, container) {
    const label = createElement('div', null, 'qs_label', container);
    label.innerHTML = title;
    return label;
  }

  function createInput (type, id, className, parent, name = '', value = '', checked = false) {
    const input = createElement('input', id, className, parent);
    input.type = type;
    name.toString() && input.setAttribute('name', name);
    value.toString() && input.setAttribute('value', value);
    checked && input.setAttribute('checked', 'checked');
    return input;
  }

  function createElement (type, id, className, parent) {
    const element = document.createElement(type);
    if (!element) return;
    id && (element.id = id);
    if (className) {
      element.className = className;
    }
    if (parent) {
      parent.appendChild(element);
    }
    return element;
  }

  /**
   * region PRIVATE/STATIC DATA AND FUNCTIONS
   */
  let cssInjected = false;
  const css = ".qs_main {text-align:left;position:absolute;font:12px sans-serif;user-select:none;-webkit-user-select:none;color:#000000;border:none}.qs_content {overflow-y:auto}.qs_title_bar {user-select:none;-webkit-user-select:none;cursor:pointer;font-weight:bold;border:none;color:#000000}.qs_container{border:none;position:relative}.qs_container_selected{border:none}.qs_range{-webkit-appearance:none;-moz-appearance:none;width:100%;height:17px;padding:0;margin:0;background-color:transparent;border:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.qs_range:focus{outline:none;border:none}.qs_range::-webkit-slider-runnable-track{width:100%;height:15px;cursor:pointer;background:#cccccc;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}.qs_range:focus::-webkit-slider-runnable-track{background:#cccccc}.qs_range::-webkit-slider-thumb{-webkit-appearance:none;height:15px;width:15px;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;background:#999999;cursor:pointer;margin-top:0}.qs_range::-moz-range-track{width:100%;height:15px;cursor:pointer;background:#cccccc;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}.qs_range::-moz-range-thumb{height:15px;width:15px;border:none;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;background:#999999;cursor:pointer}.qs_range::-ms-track{width:100%;height:15px;cursor:pointer;visibility:hidden;background:transparent}.qs_range::-ms-thumb{height:15px;width:15px;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;background:#999999;cursor:pointer;border:none}.qs_range::-ms-fill-lower{background:#cccccc;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}.qs_range:focus::-ms-fill-lower{background:#cccccc}.qs_range::-ms-fill-upper{background:#cccccc;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0}.qs_range:focus::-ms-fill-upper{background:#cccccc}.qs_button{background-color:#f6f6f6;color:#000000;height:30px;border:1px solid #aaaaaa;font:12px sans-serif}.qs_button:active{background-color:#ffffff;border:1px solid #aaaaaa}.qs_button:focus{border:1px solid #aaaaaa;outline:none}.qs_checkbox{cursor:pointer;display:inline}.qs_checkbox input{position:absolute;left:-99999px}.qs_checkbox span{height:16px;width:100%;display:block;text-indent:20px;background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAALklEQVQ4T2OcOXPmfwYKACPIgLS0NLKMmDVrFsOoAaNhMJoOGBioFwZkZUWoJgApdFaxjUM1YwAAAABJRU5ErkJggg==') no-repeat}.qs_checkbox input:checked+span{background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAvElEQVQ4T63Tyw2EIBAA0OFKBxBL40wDRovAUACcKc1IB1zZDAkG18GYZTmSmafzgTnnMgwchoDWGlJKheGcP3JtnPceCqCUAmttSZznuYtgchsXQrgC+77DNE0kUpPbmBOoJaBOIVQylnqWgAAeKhDve/AN+EaklJBzhhgjWRoJVGTbNjiOowAIret6a+4jYIwpX8aDwLIs74C2D0IIYIyVP6Gm898m9kbVm85ljHUTf16k4VUefkwDrxk+zoUEwCt0GbUAAAAASUVORK5CYII=') no-repeat}.qs_checkbox_label{position:absolute;top:7px;left:30px}.qs_label{margin-bottom:3px;user-select:none;-webkit-user-select:none;cursor:default;font:12px sans-serif}.qs_text_input{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;width:100%;padding:0 0 0 5px;height:24px;border:1px inset #ffffff;background-color:#ffffff;color:#000000;font-size:12px}.qs_text_input:focus{outline:none;background:#ffffff;border:1px inset #ffffff}.qs_select{background:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAp0lEQVRIS+2SsQ3FIAwF7RVYhA5mgQFhFuhYhJKWL0eKxI8SGylKZ0p4+OBsHGNM+HChAiS7qkgyBKrovaLeOxhjbgtxZ+cFtgelFMg5QwgBvPd/EO5sDbKAlBLUWo/8CjmL075zDmKMj6rEKbpCqBL9aqc4ZUQAhVbInBMQUXz5Vg/WfxOktXZsWWtZLds9uIqlqaH1NFV3jdhSJA47E1CAaE8ViYp+wGiWMZ/T+cgAAAAASUVORK5CYII=') no-repeat right #f6f6f6;-webkit-appearance:none;-moz-appearance:none;appearance:none;color:#000000;width:100%;height:24px;border:1px solid #aaaaaa;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;padding:0 5px;-moz-outline:none;font-size:14px}.qs_select option{font-size:14px}.qs_select::-ms-expand{display:none}.qs_select:focus{outline:none}.qs_number{height:24px}.qs_image{width:100%}.qs_progress{width:100%;height:15px;background-color:#cccccc;border:none;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.qs_progress_value{height:100%;background-color:#999999}.qs_textarea{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;resize:vertical;width:100%;padding:3px 5px;border:1px inset #ffffff;background-color:#ffffff;color:#000000;font-size:12px}.qs_textarea:focus{outline:none;background:#ffffff;border:1px inset #ffffff}.qs_color{position:absolute;left:5px;visibility:hidden}.qs_color_label{width:100%;height:20px;display:block;border:1px solid #aaaaaa;cursor:pointer;padding:0 0 0 5px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.qs_file_chooser{position:absolute;left:-999999px}.qs_file_chooser_label{background-color:#f6f6f6;color:#000000;height:30px;border:1px solid #aaaaaa;font:12px sans-serif;width:100%;display:block;cursor:pointer;padding:7px;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"; // will be injected with default css

  function injectCSS () {
    const styleTag = document.createElement('style');
    styleTag.innerText = css;
    document.head.appendChild(styleTag);
    cssInjected = true;
  }

  /**
   *
   * @alias module:QuickSettings
   * @lends module:QuickSettings.prototype
   */
  const QuickSettings = {
    _version: '3.0.2',
    _topZ: 1,
    _panel: null,
    _titleBar: null,
    _content: null,
    _startX: 0,
    _startY: 0,
    _hidden: false,
    _collapsed: false,
    _controls: null,
    _keyCode: -1,
    _draggable: true,
    _collapsible: true,
    _globalChangeHandler: null,

    /**
     * Static method. Causes QuickSettings to ignore its default styles and instead use whatever QuickSettings stylesheet is on the page. This must be called before creating any panel in order to have any effect.
     * @static
     */
    useExtStyleSheet: function () {
      cssInjected = true;
    },

    /**
     * Static method. Creates a new QuickSettings Panel
     * @param x      {Number}     x position of panel (default 0)
     * @param y      {Number}     y position of panel (default 0)
     * @param [title]    {String}     title of panel (default 'QuickSettings')
     * @param [parent]   {HTMLElement}  parent element (default document.body)
     * @returns {module:QuickSettings}    New QuickSettings Panel
     * @static
     */
    create: function (x, y, title, parent) {
      const obj = Object.create(this);
      obj._init(x, y, title, parent);
      return obj;
    },

    /**
     * Destroys the panel, removing it from the document and nulling all properties.
     */
    destroy: function () {
      if (this._panel.parentElement) {
        this._panel.parentElement.removeChild(this._panel);
      }
      for (const prop in this) {
        this[prop] = null;
      }
    },

    _init: function (x, y, title, parent) {
      if (!cssInjected) {
        injectCSS();
      }
      this._bindHandlers();
      this._createPanel(x, y, parent);
      // this._createTitleBar(title || 'QuickSettings');
      this._createContent();
    },

    _bindHandlers: function () {
      this._startDrag = this._startDrag.bind(this);
      this._drag = this._drag.bind(this);
      this._endDrag = this._endDrag.bind(this);
      this._doubleClickTitle = this._doubleClickTitle.bind(this);
      this._onKeyUp = this._onKeyUp.bind(this);
    },

    /**
     * Returns an object containing the titles and values of all user-interactive controls in this panel.
     * @param asString  {Boolean}  If true, returns a JSON formatted string of these values.
     * @returns    {Object}  An object or string containing the titles and values fo all user-interactive controls in this panel.
     */
    getValuesAsJSON: function (asString) {
      let json = {};
      for (const title in this._controls) {
        if (this._controls[title].getValue) {
          json[title] = this._controls[title].getValue();
        }
      }
      if (asString) {
        json = JSON.stringify(json);
      }
      return json;
    },

    /**
     * Sets values of any controls from a JSON object or string. The JSON is one large object with title: value elements for each control you want to set.
     * @param json {Object} A string or JS object containing the titles and values to set.
     * @returns {module:QuickSettings}
     */
    setValuesFromJSON: function (json) {
      if (typeof json === 'string') {
        json = JSON.parse(json);
      }
      for (const title in json) {
        if (this._controls[title] && this._controls[title].setValue) {
          this._controls[title].setValue(json[title]);
        }
      }
      return this;
    },

    /**
     * Sets up the panel to save all of its values to local storage. This will also immediately try to read in any saved values from local storage, if they exist.
     * So the method should be called after all controls are created on the panel.
     * @param name {String} A unique name to store the values under in localStorage.
     * @return {model:QuickSettings}
     */
    saveInLocalStorage: function (name) {
      this._localStorageName = name;
      this._readFromLocalStorage(name);
      return this;
    },

    /**
     * Clears any saved values in local storage.
     * @param name {String} The unique name in localStorage to clear.
     * @return {module:QuickSettings}
     */
    clearLocalStorage: function (name) {
      localStorage.removeItem(name); // eslint-disable-line
      return this;
    },

    _saveInLocalStorage: function (name) {
      localStorage.setItem(name, this.getValuesAsJSON(true)); // eslint-disable-line
    },

    _readFromLocalStorage: function (name) {
      const str = localStorage.getItem(name); // eslint-disable-line
      if (str) {
        this.setValuesFromJSON(str);
      }
    },

    _createPanel: function (x, y, parent) {
      this._panel = createElement('div', null, 'qs_main', parent || document.body);
      // this._panel.style.zIndex = ++QuickSettings._topZ;
      this.setPosition(x || 0, y || 0);
      this._controls = {};
    },

    _createTitleBar: function (text) {
      this._titleBar = createElement('div', null, 'qs_title_bar', this._panel);
      this._titleBar.textContent = text;

      this._titleBar.addEventListener('mousedown', this._startDrag);
      this._titleBar.addEventListener('dblclick', this._doubleClickTitle);
    },

    _createContent: function () {
      this._content = createElement('div', null, 'qs_content', this._panel);
    },

    _createContainer: function (containerId = null, className = 'qs_container') {
      const container = createElement('div', containerId, className);
      this._content.appendChild(container);
      return container;
    },

    /**
     * Positions the panel at the given location.
     * @param x  {Number} The x position.
     * @param y  {Number} The y position.
     * @returns {module:QuickSettings}
     */
    setPosition: function (x, y) {
      this._panel.style.left = x + 'px';
      this._panel.style.top = Math.max(y, 0) + 'px';
      return this;
    },

    /**
     * Sets the size of the panel.
     * @param w  {Number} The width of the panel.
     * @param h  {Number} The height of the panel.
     * @returns {module:QuickSettings}
     */
    setSize: function (w, h) {
      this._panel.style.width = w + 'px';
      this._content.style.width = w + 'px';
      this._content.style.height = (h - this._titleBar.offsetHeight) + 'px';
      return this;
    },

    /**
     * Sets the width of the panel.
     * @param w  {Number} The width of the panel.
     * @returns {module:QuickSettings}
     */
    setWidth: function (w) {
      this._panel.style.width = w + 'px';
      this._content.style.width = w + 'px';
      return this;
    },

    /**
     * Sets the height of the panel.
     * @param h  {Number} The height of the panel.
     * @returns {module:QuickSettings}
     */
    setHeight: function (h) {
      this._content.style.height = (h - this._titleBar.offsetHeight) + 'px';
      return this;
    },

    /**
     * Sets whether or not the panel can be dragged.
     * @param draggable {Boolean} Whether or not the panel can be dragged.
     * @returns {module:QuickSettings}
     */
    setDraggable: function (draggable) {
      this._draggable = draggable;
      if (this._draggable || this._collapsible) {
        this._titleBar.style.cursor = 'pointer';
      } else {
        this._titleBar.style.cursor = 'default';
      }
      return this;
    },

    _startDrag: function (event) {
      if (this._draggable) {
        // this._panel.style.zIndex = ++QuickSettings._topZ;
        document.addEventListener('mousemove', this._drag);
        document.addEventListener('mouseup', this._endDrag);
        this._startX = event.clientX;
        this._startY = event.clientY;
      }
      event.preventDefault();
    },

    _drag: function (event) {
      const x = parseInt(this._panel.style.left);
      const y = parseInt(this._panel.style.top);
      const mouseX = event.clientX;
      const mouseY = event.clientY;

      this.setPosition(x + mouseX - this._startX, y + mouseY - this._startY);
      this._startX = mouseX;
      this._startY = mouseY;
      event.preventDefault();
    },

    _endDrag: function (event) {
      document.removeEventListener('mousemove', this._drag);
      document.removeEventListener('mouseup', this._endDrag);
      event.preventDefault();
    },

    /**
     * Sets a function that will be called whenever any value in the panel is changed.
     * @param handler {Function}
     * @returns {module:QuickSettings}
     */
    setGlobalChangeHandler: function (handler) {
      this._globalChangeHandler = handler;
      return this;
    },

    _callGCH: function (title) {
      if (this._localStorageName) {
        this._saveInLocalStorage(this._localStorageName);
      }
      if (this._globalChangeHandler) {
        this._globalChangeHandler(title);
      }
    },

    /**
     * Hides the panel.
     * @returns {module:QuickSettings}
     */
    hide: function () {
      // this._panel.style.visibility = 'hidden';
      this._panel.style.display = 'none';
      this._hidden = true;
      return this;
    },

    /**
     * Shows the panel.
     * @returns {module:QuickSettings}
     */
    show: function () {
      // this._panel.style.visibility = 'visible';
      this._panel.style.display = 'block';
      // this._panel.style.zIndex = ++QuickSettings._topZ;
      this._hidden = false;
      return this;
    },

    /**
     * Toggles the panel from hidden to visible and back.
     * @returns {module:QuickSettings}
     */
    toggleVisibility: function () {
      if (this._hidden) {
        this.show();
      } else {
        this.hide();
      }
      return this;
    },

    /**
     * Sets whether or not the panel will collapse and expand when the title is double clicked.
     * @param collapsible {Boolean} Wheter or not the panel can collapse and expand.
     * @returns {module:QuickSettings}
     */
    setCollapsible: function (collapsible) {
      this._collapsible = collapsible;
      if (this._draggable || this._collapsible) {
        this._titleBar.style.cursor = 'pointer';
      } else {
        this._titleBar.style.cursor = 'default';
      }
      return this;
    },

    /**
     * Collapses the panel showing only the title bar.
     * @returns {module:QuickSettings}
     */
    collapse: function () {
      this._panel.removeChild(this._content);
      this._collapsed = true;
      return this;
    },

    /**
     * If panel is collapsed, re-expands it.
     * @returns {module:QuickSettings}
     */
    expand: function () {
      this._panel.appendChild(this._content);
      this._collapsed = false;
      return this;
    },

    /**
     * Toggles the panel back and forth between collapsed and expanded states.
     * @returns {module:QuickSettings}
     */
    toggleCollapsed: function () {
      if (this._collapsed) {
        this.expand();
      } else {
        this.collapse();
      }
      return this;
    },

    /**
     * Sets a key that, when pressed, will show and hide the panel.
     * @param char
     * @returns {module:QuickSettings}
     */
    setKey: function (char) {
      this._keyCode = char.toUpperCase().charCodeAt(0);
      document.addEventListener('keyup', this._onKeyUp);
      return this;
    },

    _onKeyUp: function (event) {
      if (event.keyCode === this._keyCode) {
        if (['INPUT', 'SELECT', 'TEXTAREA'].indexOf(event.target.tagName) < 0) {
          this.toggleVisibility();
        }
      }
    },

    _doubleClickTitle: function () {
      if (this._collapsible) {
        this.toggleCollapsed();
      }
    },

    /**
     * Removes a given control from the panel.
     * @param title {String} The title of the control to remove.
     * @returns {module:QuickSettings}
     */
    removeControl: function (title) {
      let container;
      if (this._controls[title]) {
        container = this._controls[title].container;
      }
      if (container && container.parentElement) {
        container.parentElement.removeChild(container);
      }
      this._controls[title] = null;
      return this;
    },

    /**
     * Enables the given control.
     * @param title {String} The title of the control to enable.
     * @returns {module:QuickSettings}
     */
    enableControl: function (title) {
      if (this._controls[title]) {
        this._controls[title].control.disabled = false;
      }
      return this;
    },

    /**
     * Disables the given control.
     * @param title {String} The title of the control to disable.
     * @returns {module:QuickSettings}
     */
    disableControl: function (title) {
      if (this._controls[title]) {
        this._controls[title].control.disabled = true;
      }
      return this;
    },

    /**
     * Hides the given control.
     * @param title {String} The title of the control to hide.
     * @returns {module:QuickSettings}
     */
    hideControl: function (title) {
      if (this._controls[title]) {
        this._controls[title].container.style.display = 'none';
      }
      return this;
    },

    /**
     * Shows the given control.
     * @param title {String} The title of the control to show.
     * @returns {module:QuickSettings}
     */
    showControl: function (title) {
      if (this._controls[title]) {
        this._controls[title].container.style.display = 'block';
      }
      return this;
    },

    /**
     * Changes a specific style on the given component.
     * @param title {String} The title of the control.
     * @param style {String} The name of the style.
     * @param value {letious} The new value of the style.
     * @returns {module:QuickSettings}
     */
    overrideStyle: function (title, style, value) {
      if (this._controls[title]) {
        this._controls[title].control.style[style] = value;
      }
      return this;
    },

    /**
     * Hides the title label of a given control.
     * @param title {String} The title of the control.
     * @returns {module:QuickSettings}
     */
    hideTitle: function (title) {
      const label = this._controls[title].label;
      if (label) {
        label.style.display = 'none';
      }
      return this;
    },

    /**
     * Shows the title label of a given control.
     * @param title {String} The title of the control.
     * @returns {module:QuickSettings}
     */
    showTitle: function (title) {
      const label = this._controls[title].label;
      if (label) {
        label.style.display = 'block';
      }
      return this;
    },

    /**
     * Hides the title labels of all controls.
     * @returns {module:QuickSettings}
     */
    hideAllTitles: function () {
      for (const title in this._controls) {
        const label = this._controls[title].label;
        if (label) {
          label.style.display = 'none';
        }
      }
      return this;
    },

    /**
     * Shows the title labels of all controls. Button and booleans have no title labels.
     * @returns {module:QuickSettings}
     */
    showAllTitles: function () {
      for (const title in this._controls) {
        const label = this._controls[title].label;
        if (label) {
          label.style.display = 'block';
        }
      }
      return this;
    },

    getValue: function (title) {
      return this._controls[title].getValue();
    },

    setValue: function (title, value) {
      this._controls[title].setValue(value);
      this._callGCH(title);
      return this;
    },

    hideMenuElements: function (title, value) {
      this._controls[title].hideMenuElements(value);
      this._callGCH(title);
      return this;
    },

    showMenuElements: function (title, value) {
      this._controls[title].showMenuElements(value);
      this._callGCH(title);
      return this;
    },

    changeColorPalette: function (title, value, textures, defaultColors) {
      this._controls[title].changeColorPalette(value, textures, defaultColors);
      this._callGCH(title);
      return this;
    },

    changePatternColorPalette: function (title, patternIndex, palette, defaultColors, isTexture, mapColorToPattern, patternColorName) {
      this._controls[title].changePatternColorPalette(patternIndex, palette, defaultColors, isTexture, mapColorToPattern, patternColorName);
      this._callGCH(title);
      return this;
    },

    /**
     * Adds a checkbox to the panel.
     * @param title {String} The title of this control.
     * @param value {Boolean} The initial value of this control.
     * @param [callback] {Function} A callback function that will be called when the value of this control changes.
     * @returns {module:QuickSettings}
     */
    addBoolean: function (title, value, callback) {
      const container = this._createContainer();

      const id = getNextID();
      const label = createElement('label', null, 'qs_checkbox_label', container);
      label.textContent = title;
      label.setAttribute('for', id);

      const checkbox = createElement('label', null, 'qs_checkbox', container);
      checkbox.setAttribute('for', id);
      const input = createInput('checkbox', id, null, checkbox);
      input.checked = value;

      this._controls[title] = {
        container: container,
        control: input,
        getValue: function () {
          return this.control.checked;
        },
        setValue: function (value) {
          this.control.checked = value;
          if (callback) {
            callback(value);
          }
        }
      };

      const self = this;
      input.addEventListener('change', function () {
        if (callback) {
          callback(input.checked);
        }
        self._callGCH(title);
      });
      return this;
    },

    /**
     * Adds a checkbox to the panel, bound to an object
     * @param title {String} The title of this control.
     * @param value {Boolean} The initial value of this control.
     * @param object {Object} Object the control is bound to. When the value of the control changes, a property on this object, with the name of the title of this control, will be set to the current value of this control.
     * @returns {module:QuickSettings}
     */
    bindBoolean: function (title, value, object) {
      return this.addBoolean(title, value, function (value) {
        object[title] = value;
      });
    },

    addBooleanSwitch: function (title, value, callback, notCheckedHtml = '', checkedHtml = '') {
      const container = this._createContainer();
      const id = getNextID();

      const checkbox = createElement('label', null, 'qs_boolean_switch', container);
      checkbox.setAttribute('for', id);

      const input = createInput('checkbox', id, null, checkbox);
      input.checked = value;

      const span = createElement('span', null, 'qs_boolean_switch_checkbox_span', checkbox);
      const textWrapperDiv = createElement('div', null, 'qs_boolean_switch_checkbox_text_wrapper', span);
      const sliderNotCheckedText = createElement('div', null, 'qs_boolean_switch_checkbox_text_not_checked', textWrapperDiv);
      const sliderCheckedText = createElement('div', null, 'qs_boolean_switch_checkbox_text_checked', textWrapperDiv);

      sliderCheckedText.innerHTML = checkedHtml;
      sliderNotCheckedText.innerHTML = notCheckedHtml;

      this._controls[title] = {
        container: container,
        control: input,
        getValue: function () {
          return this.control.checked;
        },
        setValue: function (value) {
          this.control.checked = value;
          if (callback) {
            callback(value);
          }
        }
      };

      const self = this;
      input.addEventListener('change', function () {
        if (callback) {
          callback(input.checked);
        }
        self._callGCH(title);
      });
      return this;
    },

    bindBooleanSwitch: function (title, value, object) {
      return this.addBooleanSwitch(title, value, function (value) {
        object[title] = value;
      });
    },

    /**
     * Create menu navigation
     * @param {*} title
     * @param {*} selected - what is selected by default
     * @param {*} callback - on change
     * @param {*} elements - array of menu items object [{title: 'name', img: 'location_of_img'}, {}, {}]
     */
    menuNavigation: function (title, selectedElIndex = 1, callback, navElements) {
      const self = this;
      const elements = navElements;
      const container = this._createContainer();

      const menuNavigationWrapper = createElement('div', 'menu-navigation-wrapper', 'menu-navigation', container);
      const menuArrowsWrapper = createElement('div', 'menu-navigation-arrows-wrapper', 'menu-navigation', container);

      // create menu
      const radioButtonsElements = [];
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const id = element.id;
        const radioId = 'radio-id-' + id;

        const radioLabel = createElement('label', null, 'radio-label-' + id, menuNavigationWrapper);
        radioLabel.setAttribute('for', radioId);

        const radio = createInput('radio', radioId, null, radioLabel, 'menuNavigation', id, selectedElIndex === i);
        radioButtonsElements[i] = radio;

        if (i === selectedElIndex) {
          radio.checked = true;
          radioLabel.classList.add('selected');
        }

        const img = createElement('img', null, 'radio-image-' + id, radioLabel);
        img.src = element.img_src;
      }
      const logicS = createElement('a', null, 'logicS', menuNavigationWrapper);
      logicS.innerHTML = '&nbspLogic Solutions';
      logicS.href = 'https://logics.rs/portfolio/swistrax-garage-floor-designer/';
      logicS.target = '_blank';

      // set control value
      const controlValue = menuNavigationWrapper.querySelector('input[name = menuNavigation]:checked') && menuNavigationWrapper.querySelector('input[name = menuNavigation]:checked').value;
      const findElementIndex = (e) => e.id === +controlValue;
      const currElIndex = elements.findIndex(findElementIndex);

      // create arrows
      // left
      const leftArrowWrapper = createElement('div', 'menu-navigation-left-arrow-wrapper', 'menu-navigation', menuArrowsWrapper);
      const leftArrowContainer = createElement('div', 'menu-navigation-left-arrow', 'menu-navigation', leftArrowWrapper);
      const arrowLeft = createElement('div', 'menu-navigation-left-arrow', 'arrow left', leftArrowContainer);
      const leftTextWrapper = createElement('div', 'menu-navigation-left-arrow-text-wrapper', 'menu-navigation', leftArrowWrapper);
      const leftTopText = createElement('div', 'menu-navigation-left-arrow-text-top', 'menu-navigation', leftTextWrapper);
      const leftBottomText = createElement('div', 'menu-navigation-left-arrow-bottom', 'menu-navigation', leftTextWrapper);
      leftTopText.innerHTML = 'BACK';
      const leftTextIndex = (+currElIndex - 1 < 0) ? 0 : +currElIndex - 1;
      leftBottomText.innerHTML = elements[leftTextIndex].title;

      // middle
      const middleMenuText = createElement('div', 'menu-navigation-middle', 'menu-navigation', menuArrowsWrapper);
      middleMenuText.innerHTML = (elements[currElIndex] && elements[currElIndex].title) || '';

      // right
      const rightArrowWrapper = createElement('div', 'menu-navigation-right-arrow-wrapper', 'menu-navigation', menuArrowsWrapper);
      const rightTextWrapper = createElement('div', 'menu-navigation-right-arrow-text-wrapper', 'menu-navigation', rightArrowWrapper);
      const rightTopText = createElement('div', 'menu-navigation-right-arrow-text-top', 'menu-navigation', rightTextWrapper);
      const rightBottomText = createElement('div', 'menu-navigation-right-arrow-bottom', 'menu-navigation', rightTextWrapper);
      rightTopText.innerHTML = 'NEXT';
      const rightTextIndex = (+currElIndex - 1 < elements.length) ? +currElIndex + 1 : elements.length;
      rightBottomText.innerHTML = elements[rightTextIndex].title;
      const rightArrowContainer = createElement('div', 'menu-navigation-right-arrow', 'menu-navigation', rightArrowWrapper);
      const arrowRight = createElement('div', 'menu-navigation-right-arrow', 'arrow right', rightArrowContainer);

      this._controls[title] = {
        container: container,
        control: controlValue,
        elements: elements,
        origElements: elements,
        getValue: function () {
          return this.control;
        },
        setValue: function (value) {
          setRadioValue(value);
        },
        hideMenuElements: function (element) {
          const filteredItems = self._controls[title].elements.filter(function (item) {
            return item.id !== element.id;
          });
          self._controls[title].elements = filteredItems;
          toggleNavElementVisible(element.id, false);
        },
        showMenuElements: function (element) {
          self._controls[title].elements = self._controls[title].origElements;
          toggleNavElementVisible(element.id, true);
        }
      };

      const toggleNavElementVisible = (id, state) => {
        const className = 'radio-label-' + id;
        const el = menuNavigationWrapper.querySelector(`.${className}`);
        state ? el.style.display = 'flex' : el.style.display = 'none';
      };

      const setRadioValue = (value) => {
        const elements = self._controls[title].elements;
        const scn = 'radio-label-' + value;
        const oldValue = +self._controls[title].control;
        if (oldValue === +value) {
          return true;
        }
        const newValue = self._controls[title].control = +value;
        if (value === 100 || value === -1) {
          return callback(value);
        }
        // update selected values
        const selectedElements = menuNavigationWrapper.querySelector('label.selected');
        selectedElements && selectedElements.classList.remove('selected');

        const findElement = (e) => e.id === newValue;
        const currIndex = elements.findIndex(findElement);
        const previousIndex = currIndex - 1;
        const nextIndex = currIndex + 1;
        const currEl = elements[currIndex];
        const previousEl = elements[previousIndex] || elements[newValue];
        const nextEl = elements[nextIndex] || elements[newValue];
        if (!currEl) return true;

        // const label = menuNavigationWrapper.children[value];
        const label = menuNavigationWrapper.querySelector(`.${scn}`);
        label.classList.add('selected');
        const radioButton = label.firstChild;
        radioButton.checked = true;

        // update middle text
        middleMenuText.innerHTML = currEl.title;

        // update right index
        rightBottomText.innerHTML = +currIndex + 1 < elements.length ? nextEl.title : '';
        if (+currIndex + 1 < elements.length) {
          arrowRight.style.display = 'block';
          rightTopText.style.display = 'block';
          rightArrowWrapper.classList.add('rightArrowWrapperRedBackground');
        } else {
          arrowRight.style.display = 'none';
          rightTopText.style.display = 'none';
          rightArrowWrapper.classList.remove('rightArrowWrapperRedBackground');
        }

        // update left index
        leftBottomText.innerHTML = +currIndex - 1 >= 0 ? previousEl.title : '';
        if (+currIndex - 1 >= 0) {
          arrowLeft.style.display = 'block';
          leftTopText.style.display = 'block';
        } else {
          arrowLeft.style.display = 'none';
          leftTopText.style.display = 'none';
        }

        if (callback) {
          callback(self._controls[title].elements[currIndex].id);
        }
      };

      menuNavigationWrapper.addEventListener('click', function (event) {
        if (event.target && event.target.matches("input[type='radio']")) {
          const newValue = menuNavigationWrapper.querySelector('input[name = menuNavigation]:checked').value;
          setRadioValue(newValue);
        }
        self._callGCH(title);
      });

      leftArrowWrapper.addEventListener('click', function (event) {
        event.stopPropagation();
        const currentPage = self._controls[title].control;
        const elements = self._controls[title].elements;
        const next = nextValue(currentPage, 'left');
        if (currentPage === 100) {
          setRadioValue(elements[+elements.length - 2].id);
        } else if (currentPage === -1 || (currentPage < 0)) {
          setRadioValue(-1);
        } else {
          setRadioValue(next);
        }
        self._callGCH(title);
      });

      rightArrowWrapper.addEventListener('click', function (event) {
        event.stopPropagation();
        const currentPage = self._controls[title].control;
        const elements = self._controls[title].elements;
        const next = nextValue(currentPage, 'right');

        if (currentPage === -1) {
          setRadioValue(1);
        } else if (currentPage === 100 || (currentPage > +elements.length - 1)) {
          setRadioValue(100);
        } else {
          setRadioValue(next);
        }
        self._callGCH(title);
      });

      const nextValue = (value, direction = 'left') => {
        const elements = self._controls[title].elements;
        const findElement = (e) => e.id === value;
        const currIndex = elements.findIndex(findElement);
        const nextElementId = direction === 'left'
          ? elements[currIndex - 1] && elements[currIndex - 1].id
          : elements[currIndex + 1] && elements[currIndex + 1].id;
        if (!nextElementId && direction === 'right') {
          return 100;
        } else if ((!nextElementId && nextElementId !== 0) && direction === 'left') {
          return -1;
        }
        return nextElementId;
      };

      return this;
    },

    bindMenuNavigation: function (title, value, object) {
      return this.menuNavigation(title, value, function (value) {
        object[title] = value;
      });
    },

    addTileSelector: function (title, callback, callbackPopUpShown, elements, selected = 0, units = 'imperial') {
      const self = this;
      const controlValue = selected;
      const container = this._createContainer('tile-selector-container');
      const menuTileSelectorWrapper = createElement('div', 'tile-selector-wrapper', 'tile-selector', container);
      const imgWrapperSelector = createElement('div', 'tile-selector-img-wrapper', 'tile-selector-img', menuTileSelectorWrapper);
      const imgSelector = createElement('img', null, 'tile-img', imgWrapperSelector);
      imgSelector.src = elements[selected].img_src;

      // create pop-up
      const popUp = createElement('div', 'pop-up', 'pop-up', container);
      const popUpWrapper = createElement('div', 'pop-up-wapper', 'pop-up-wapper', popUp);

      // tiles
      const popUpTiles = createElement('div', 'pop-up-tiles', 'pop-up-tiles', popUpWrapper);

      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const tileImgId = 'tile-id-' + i;

        const imgDiv = createElement('div', tileImgId, 'tile-img-div', popUpTiles);
        const img = createElement('img', null, 'tile', imgDiv);
        img.src = element.img_src;
        // const pointer = createElement('div', 'pointer-' + tileImgId, 'tile-pointer', imgDiv);

        if (i === selected) {
          imgDiv.classList.add('selected');
        }

        imgDiv.addEventListener('click', function () {
          self._controls[title].chooseTile(i);
          self._callGCH(title);
        });
      }

      const popUpContentWrapper = createElement('div', 'pop-up-content-wrapper', 'pop-up-content-wrapper', popUpWrapper);
      const popUpContent = createElement('div', 'pop-up-content', 'pop-up-content', popUpContentWrapper);

      // pop up nav
      const popUpNav = createElement('div', 'pop-up-nav', 'pop-up-nav', popUpContent);
      const leftNav = createElement('div', 'pop-up-nav-left', 'pop-up-nav-left', popUpNav);
      const leftNavIcon = createElement('img', null, 'pop-up-nav-icon', leftNav);
      const leftNavText = createElement('div', 'pop-up-nav-text', 'pop-up-nav-text', leftNav);
      leftNavText.innerHTML = 'Choose Tile';
      leftNavIcon.src = pointFinger;
      const rightNav = createElement('div', 'pop-up-nav-right', 'pop-up-nav-right', popUpNav);
      rightNav.innerHTML = `<img src="${closeSvg}"/>`;

      const popUpContentFlex = createElement('div', 'pop-up-content-flex', 'pop-up-content-flex', popUpContent);

      // left content
      const popUpContentLeft = createElement('div', 'pop-up-content-left', 'pop-up-content-left', popUpContentFlex);
      const leftTitle = createElement('div', 'pop-up-content-left-title', 'pop-up-content-left-title', popUpContentLeft);
      const leftDimensions = createElement('div', 'pop-up-content-left-dimesions', 'pop-up-content-left-dimensions', popUpContentLeft);
      const priceWrapper = createElement('div', 'pop-up-content-price-wrapper', 'pop-up-content-price-wrapper', popUpContentLeft);
      const valute = createElement('div', 'pop-up-content-price-valute', 'pop-up-content-price-valute', priceWrapper);
      const priceWrapper2 = createElement('div', null, 'pop-up-content-price-wrapper-2', priceWrapper);
      const price = createElement('div', 'pop-up-content-price-price', 'pop-up-content-price-price', priceWrapper2);
      const areaName = createElement('div', 'pop-up-content-price-area', 'pop-up-content-price-area', priceWrapper2);
      const priceSpecColorWrapper = createElement('div', 'pop-up-content-spec-price-wrapper', 'pop-up-content-spec-price-wrapper', popUpContentLeft);
      priceSpecColorWrapper.innerHTML = selected === 0 ? config.specColorsPrice : '';
      const leftTileDescription = createElement('div', 'pop-up-content-left-description', 'pop-up-content-left-description', popUpContentLeft);
      leftTitle.innerHTML = elements[selected].title;
      leftDimensions.innerHTML = elements[selected].dimensions(units);
      leftTileDescription.innerHTML = elements[selected].desc;

      // right content
      const popUpContentRight = createElement('div', 'pop-up-content-right', 'pop-up-content-right', popUpContentFlex);
      valute.innerHTML = 'Standard Colors:&nbsp';
      price.innerHTML = `${elements[selected].price}`;
      areaName.innerHTML = `${elements[selected].priceUnit}`;

      // bottom content
      const popUpContentBackgroundImage = createElement('img', '', 'pop-up-content-bg-image', popUpContentRight);
      const popUpContentButton = createElement('div', 'pop-up-content-button', 'pop-up-content-button', popUpContentWrapper);
      popUpContentBackgroundImage.src = elements[selected].bg_img;
      popUpContentButton.innerHTML = 'Select Tile';

      // add controls
      this._controls[title] = {
        container: container,
        control: controlValue,
        popUpOpen: false,
        optionSelected: null, // this option is preselected, not confirmed
        getValue: function () {
          return this.control;
        },
        setValue: function (value) {
          setSelectedValue(value);
        },
        togglePopUp: function () {
          this.popUpOpen = !this.popUpOpen;
          if (this.popUpOpen) {
            popUp.classList.add('shown');
            callbackPopUpShown && callbackPopUpShown(true);
          } else {
            popUp.classList.remove('shown');
            callbackPopUpShown && callbackPopUpShown(false);
          }
        },
        chooseTile: function (tileIndex) {
          preSelectTile(tileIndex);
        }
      };

      const preSelectTile = (tileIndex) => {
        // remove sleected class for all elements
        const pointerElements = popUpTiles.querySelectorAll('.tile-img-div');
        for (let i = 0; i < pointerElements.length; i++) {
          pointerElements[i].classList.remove('selected');
        }

        // select tile
        const pointerID = 'tile-id-' + tileIndex;
        const selected = document.getElementById(pointerID);
        selected.classList.add('selected');

        // change text
        leftTitle.innerHTML = elements[tileIndex].title;
        price.innerHTML = elements[tileIndex].price;
        areaName.innerHTML = elements[tileIndex].priceUnit;
        priceSpecColorWrapper.innerHTML = tileIndex === 0 ? config.specColorsPrice : '';
        valute.innerHTML = tileIndex === 0 ? `${config.standardColorsPrice}:&nbsp` : '$';
        leftDimensions.innerHTML = elements[tileIndex].dimensions(units);
        leftTileDescription.innerHTML = elements[tileIndex].desc;
        popUpContentBackgroundImage.src = elements[tileIndex].bg_img;

        popUpContentWrapper.scrollTop = 0;
        self._controls[title].optionSelected = tileIndex;
      };

      const setSelectedValue = (value) => {
        const oldValue = +self._controls[title].control;
        if (oldValue === +value) {
          return false;
        }

        self._controls[title].control = +value;
        imgSelector.src = elements[value].img_src;
        if (callback) {
          callback(self._controls[title].control);
        }
      };

      imgSelector.addEventListener('click', function () {
        self._controls[title].togglePopUp();
        self._callGCH(title);
      });

      rightNav.addEventListener('click', function () {
        self._controls[title].togglePopUp();
        self._callGCH(title);
      });

      popUpContentButton.addEventListener('click', function () {
        World.preloader.show();
        popUp.classList.remove('shown');
        setTimeout(() => {
          if (self._controls[title].control !== self._controls[title].optionSelected && self._controls[title].optionSelected !== null) {
            setSelectedValue(self._controls[title].optionSelected);
          }
          self._controls[title].togglePopUp();
          self._callGCH(title);

          World.preloader.hide();
        }, 50);
      });

      popUp.addEventListener('click', function (e) {
        if (self._controls[title].popUpOpen && e.target.id === 'pop-up') {
          self._controls[title].togglePopUp();
        }
      });

      return this;
    },

    bindTileSelector: function (title, value, object) {
      return this.addTileSelector(title, value, (value) => {
        object[title] = value;
      });
    },

    findColorNameFromColorPalette: function (color, palette = config.allColorPalettePro) {
      return palette.find(e => {
        return e.color === color;
      });
    },

    addPatern: function (title, callback, callbackPopUpShown, patterns, selectedPattern = 0, colorPalette) {
      const findColorNameBasedOnHex = (hex, palette = colorPalette) => {
        return palette.find(e => {
          return e.color === hex;
        });
      };

      const hexDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
      const hex = (x) => { return isNaN(x) ? '00' : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16]; };
      const rgb2hex = (rgb) => {
        if (rgb.indexOf('#') > -1) return rgb;
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return '#' + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
      };

      const mapPatternToColorBox = (value) => {
        switch (value) {
          case 0: return 'patternColor1';
          case 1: return 'patternColor2';
          case 2: return 'patternColor3';
          case 3: return 'patternColor4';
          default: return 'patternColor1';
        }
      };

      const self = this;
      const controlValue = selectedPattern;
      const container = this._createContainer('pattern-container');

      const menuPatternSelectorWrapper = createElement('div', 'pattern-wrapper', 'pattern', container);
      const imgWrapperSelector = createElement('div', 'pattern-img-wrapper', 'pattern-img-wrapper', menuPatternSelectorWrapper);
      const imgSelector = createElement('div', 'pattern-img-select', 'pattern-img-select', imgWrapperSelector);
      imgSelector.innerHTML = patterns[selectedPattern].svg;

      // create pop-up
      const popUp = createElement('div', 'pattern-pop-up', 'pattern-pop-up', container);
      const popUpWrapper = createElement('div', 'pattern-pop-up-wrapper', 'pattern-pop-up-wrapper', popUp);

      // pop up nav
      const popUpNav = createElement('div', 'pop-up-nav', 'pop-up-nav', popUpWrapper);
      const leftNav = createElement('div', 'pop-up-nav-left', 'pop-up-nav-left', popUpNav);
      const leftNavIcon = createElement('img', null, 'pop-up-nav-icon', leftNav);
      const leftNavText = createElement('div', 'pop-up-nav-text', 'pop-up-nav-text', leftNav);
      leftNavText.innerHTML = 'Select Pattern';
      leftNavIcon.src = pointFinger;
      const rightNav = createElement('div', 'pop-up-nav-right', 'pop-up-nav-right', popUpNav);
      rightNav.innerHTML = `<img src="${closeSvg}"/>`;

      const contentWrapper = createElement('div', 'pattern-pop-up-content-wrapper', 'pattern-pop-up-content-wrapper', popUpWrapper);

      // patterns
      const popUpPattern = createElement('div', 'pop-up-patterns', 'pop-up-patterns', contentWrapper);
      for (let i = 0; i < patterns.length; i++) {
        const element = patterns[i];
        const tileImgId = 'pattern-id-' + i;

        const imgDiv = createElement('div', tileImgId, 'pattern-img-div', popUpPattern);
        const img = createElement('div', null, 'pattern-img', imgDiv);
        img.innerHTML = element.svg;

        if (i === selectedPattern) {
          img.classList.add('selected');
        }

        img.addEventListener('click', function (event) {
          event.stopPropagation();
          const target = event.target;
          self._controls[title].choosePattern(i, target);
          self._callGCH(title);
        });
      }

      // colors
      const colorsWrapper = createElement('div', 'pop-up-colors', 'pop-up-colors', contentWrapper);
      const colors = 4;
      const colorPaletteDefault = config.tiles[0].defaultPatternColors;
      for (let i = 0; i < colors; i++) {
        const colorDivId = 'color-id-' + i;
        const colorDiv = createElement('div', colorDivId, 'color-div', colorsWrapper);
        const text = createElement('div', null, 'color-text', colorDiv);
        text.innerHTML = 'Color ' + (i + 1);
        const colorWrapper = createElement('div', null, 'color-wrapper', colorDiv);
        const color = createElement('div', null, 'color', colorWrapper);
        color.style.backgroundColor = colorPaletteDefault[i];

        const colorName = createElement('div', null, 'color-name', colorDiv);
        colorName.innerHTML = findColorNameBasedOnHex(colorPaletteDefault[i]).name;

        color.addEventListener('click', function () {
          self._controls[title].chooseActiveColorBox(i, this);
          self._callGCH(title);
        });
      }

      // update color divs & svg fill colors
      colorPaletteDefault.map((e, i) => {
        const patternColorName = mapPatternToColorBox(i);
        Array.from(document.getElementsByClassName(patternColorName))
          .forEach(tile => {
            tile.style.fill = e;
          });
        return e;
      });

      // palette
      const palettesWrapperBlock = createElement('div', 'pop-up-colors-palette', 'pop-up-colors-palette', contentWrapper);
      palettesWrapperBlock.style.display = 'none';
      const palettesWrapper = createElement('div', 'pop-up-colors-palette-flex', 'pop-up-colors-palette-flex', palettesWrapperBlock);
      const paletteSize = colorPalette.length || 0;
      for (let i = 0; i < paletteSize; i++) {
        const paletteDivId = 'palette-id-' + i;
        const paletteDiv = createElement('div', paletteDivId, 'palette-div', palettesWrapper);
        const paletteWrapper = createElement('div', null, 'palette-wrapper', paletteDiv);
        const palette = createElement('div', null, 'palette', paletteWrapper);
        palette.style.backgroundColor = colorPalette[i].color;
        palette.addEventListener('click', function () {
          self._controls[title].selectColor(i, this);
          self._callGCH(title);
        });
      }

      // add controls
      this._controls[title] = {
        container: container,
        control: controlValue,
        controlColor: colorPaletteDefault,
        popUpOpen: false,
        patternSelected: controlValue,
        colorPanelVisible: false,
        selectedColor: null,
        colors: colorPaletteDefault,
        isTexture: false,
        textureColors: [],
        patternColorNames: [...colorPalette],
        getValue: function () {
          return this.control;
        },
        changePatternColorPalette: function (patternIndex, palette, defaultColors, isTexture, mapColorToPattern, patternColorName) {
          this.isTexture = isTexture;
          this.textureColors = defaultColors;
          this.patternColorNames = patternColorName;

          // find patern color indexes
          const pci = [];
          if (isTexture) {
            for (let i = 0; i < defaultColors.length; i++) {
              const findPatternIndexByColor = mapColorToPattern.indexOf(defaultColors[i]);
              pci.push(findPatternIndexByColor);
            }
          }
          this.control = patternIndex;
          this.controlColor = [...defaultColors];
          this.colors = isTexture ? [...pci] : [...defaultColors];

          // recreate divs for selecting colors
          while (colorsWrapper.firstChild) {
            colorsWrapper.removeChild(colorsWrapper.firstChild);
          }
          for (let i = 0; i < defaultColors.length; i++) {
            const colorDivId = 'color-id-' + i;
            const colorDiv = createElement('div', colorDivId, 'color-div', colorsWrapper);
            const text = createElement('div', null, 'color-text', colorDiv);
            text.innerHTML = 'Color ' + (i + 1);
            const colorWrapper = createElement('div', null, 'color-wrapper', colorDiv);
            let color;
            if (isTexture) {
              color = createElement('img', null, 'color', colorWrapper);
              const findPatternIndexByColor = mapColorToPattern.indexOf(defaultColors[i]);
              color.src = palette[findPatternIndexByColor];
              color.style.backgroundColor = defaultColors[i];
            } else {
              color = createElement('div', null, 'color', colorWrapper);
              color.style.backgroundColor = defaultColors[i];
            }
            const colorName = createElement('div', null, 'color-name', colorDiv);
            if (isTexture) {
              colorName.innerHTML = findColorNameBasedOnHex(defaultColors[i], patternColorName).name;
            } else {
              colorName.innerHTML = findColorNameBasedOnHex(defaultColors[i]).name;
            }
            color.addEventListener('click', function () {
              self._controls[title].chooseActiveColorBox(i, this);
              self._callGCH(title);
            });
          }

          // update preselect pattern
          const patternIdParent = 'pattern-id-' + selectedPattern;
          const patternEl = document.getElementById(patternIdParent);
          const childEl = patternEl.firstChild;
          preSelectPattern(selectedPattern, childEl);

          // update color divs & svg fill colors
          defaultColors.map((e, i) => {
            const patternColorName = mapPatternToColorBox(i);
            const colorId = 'color-id-' + i;
            const colorIdWrapper = document.getElementById(colorId);
            const color = colorIdWrapper.getElementsByClassName('color');
            color[0].style.backgroundColor = e;
            const colorName = colorIdWrapper.getElementsByClassName('color-name');
            colorName[0].innerHTML = findColorNameBasedOnHex(e, config.allColorPalettePro).name;
            Array.from(document.getElementsByClassName(patternColorName))
              .forEach(tile => {
                tile.style.fill = e;
              });
            return e;
          });

          // update used color pattern
          // remove all child elements and its event handlers
          while (palettesWrapper.firstChild) {
            palettesWrapper.removeChild(palettesWrapper.firstChild);
          }

          // create new color palette
          for (let i = 0; i < palette.length; i++) {
            const paletteDivId = 'palette-id-' + i;
            const paletteDiv = createElement('div', paletteDivId, 'palette-div', palettesWrapper);
            const paletteWrapper = createElement('div', null, 'palette-wrapper', paletteDiv);

            let paletteColorDiv;
            if (isTexture) {
              paletteColorDiv = createElement('img', null, 'palette', paletteWrapper);
              paletteColorDiv.src = palette[i];
              paletteColorDiv.style.backgroundColor = mapColorToPattern[i];
            } else {
              paletteColorDiv = createElement('div', null, 'palette', paletteWrapper);
              paletteColorDiv.style.backgroundColor = palette[i];
            }
            paletteColorDiv.addEventListener('click', function () {
              self._controls[title].selectColor(i, this, isTexture);
              self._callGCH(title);
            });
          }

          // update main svg pattern
          setSelectedValue(false);
        },
        togglePopUp: function () {
          this.popUpOpen = !this.popUpOpen;
          self._controls[title].colorPanelVisible = false;
          palettesWrapperBlock.style.display = 'none';
          if (this.popUpOpen) {
            popUp.classList.add('shown');
            callbackPopUpShown && callbackPopUpShown(true);
          } else {
            self._controls[title].selectedColor = null;
            const el = document.getElementsByClassName('color selected')[0];
            el && el.classList.remove('selected');
            popUp.classList.remove('shown');
            callbackPopUpShown && callbackPopUpShown(false);
          }
        },
        choosePattern: function (patternIndex, el) {
          preSelectPattern(patternIndex, el);
          setSelectedValue();
        },
        chooseActiveColorBox: function (activeColorBox, el) {
          if (!self._controls[title].colorPanelVisible) {
            self._controls[title].colorPanelVisible = true;
            palettesWrapperBlock.style.display = 'flex';
          }
          const selectedElement = document.getElementsByClassName('color selected');
          selectedElement && selectedElement.length && selectedElement[0].classList.remove('selected');
          el.classList.add('selected');
          self._controls[title].selectedColor = activeColorBox;
        },
        selectColor: function (colorIndex, el, isTexture) {
          const selectedColorBoxId = self._controls[title].selectedColor;
          const color = rgb2hex(el.style.backgroundColor);
          let colorObject;
          if (isTexture) {
            const vinilColorNames = self._controls[title].patternColorNames;
            colorObject = findColorNameBasedOnHex(rgb2hex(color), vinilColorNames);
          } else {
            colorObject = findColorNameBasedOnHex(rgb2hex(color));
          }

          if (selectedColorBoxId === null) return;
          if (isTexture) {
            self._controls[title].colors[selectedColorBoxId] = colorIndex;
            self._controls[title].controlColor[selectedColorBoxId] = colorIndex;
          } else {
            self._controls[title].colors[selectedColorBoxId] = color;
            self._controls[title].controlColor[selectedColorBoxId] = color;
          }
          const colorEl = document.getElementsByClassName('color selected');
          colorEl && colorEl.length && (colorEl[0].style.backgroundColor = color);
          if (isTexture) {
            colorEl && colorEl.length && (colorEl[0].src = el.src);
          }

          const parent = colorEl[0].parentElement.parentElement;
          const colorNameDiv = parent.querySelector('.color-name');
          colorNameDiv.innerHTML = colorObject.name;

          const patternName = mapPatternToColorBox(selectedColorBoxId);
          Array.from(document.getElementsByClassName(patternName))
            .forEach(tile => {
              tile.style.fill = color;
            });

          if (callback) {
            const returnObj = {
              pattern: self._controls[title].control,
              colors: {
                patternColor1: self._controls[title].controlColor[0],
                patternColor2: self._controls[title].controlColor[1],
                patternColor3: self._controls[title].controlColor[2],
                patternColor4: self._controls[title].controlColor[3]
              }
            };
            callback(returnObj);
          }
        }
      };

      const preSelectPattern = (patternIndex, el) => {
        const selectedElement = document.getElementsByClassName('pattern-img selected');
        selectedElement[0].classList.remove('selected');
        el.classList.add('selected');
        self._controls[title].patternSelected = patternIndex;
      };

      const updateSelectedFrontImage = () => {
        imgSelector.innerHTML = patterns[self._controls[title].control].svg;
        const array = self._controls[title].controlColor;
        for (let index = 0; index < array.length; index++) {
          const patternName = mapPatternToColorBox(index);
          Array.from(imgSelector.getElementsByClassName(patternName))
            .forEach(tile => {
              if (self._controls[title].isTexture) {
                tile.style.fill = self._controls[title].textureColors[index];
              } else {
                tile.style.fill = array[index];
              }
            });
        }
      };

      const setSelectedValue = (togglePopup = true) => {
        const selectedPattern = self._controls[title].patternSelected;
        self._controls[title].control = selectedPattern;
        self._controls[title].controlColor = self._controls[title].colors;
        updateSelectedFrontImage();
        if (callback) {
          const returnObj = {
            pattern: self._controls[title].control,
            colors: {
              patternColor1: self._controls[title].controlColor[0],
              patternColor2: self._controls[title].controlColor[1],
              patternColor3: self._controls[title].controlColor[2],
              patternColor4: self._controls[title].controlColor[3]
            },
            isTexture: self._controls[title].isTexture
          };
          callback(returnObj);
        }
        togglePopup && self._controls[title].togglePopUp();
      };

      imgSelector.addEventListener('click', function () {
        self._controls[title].togglePopUp();
        self._callGCH(title);
      });

      rightNav.addEventListener('click', function () {
        self._controls[title].togglePopUp();
        self._callGCH(title);
      });

      popUp.addEventListener('click', function (e) {
        if (self._controls[title].popUpOpen && e.target.id === 'pattern-pop-up') {
          self._controls[title].togglePopUp();
        }
      });

      return this;
    },

    bindPatern: function (title, value, object) {
      return this.addPatern(title, value, (value) => {
        object[title] = value;
      });
    },

    addSingleTileSelector: function (title, callback, callbackPopUpShown, elements, selected = 0, units = 'imperial') {
      const self = this;
      const controlValue = selected;
      const selectedType = elements[selected].tileType;
      const container = this._createContainer('single-tile-selector-container');
      const menuTileSelectorWrapper = createElement('div', 'single-tile-selector-wrapper', 'single-tile-selector', container);
      const imgWrapperSelector = createElement('div', 'single-tile-selector-img-wrapper', 'single-tile-selector-img', menuTileSelectorWrapper);
      const imgSelector = createElement('img', null, 'single-tile-img', imgWrapperSelector);
      imgSelector.src = elements[selected].img_src;

      // create pop-up
      const popUp = createElement('div', 'pop-up', 'pop-up', container);
      const popUpWrapper = createElement('div', 'pop-up-wapper', 'pop-up-wapper', popUp);

      // tiles
      const popUpTiles = createElement('div', 'pop-up-tiles', 'pop-up-tiles', popUpWrapper);
      for (let i = 0; i < elements.length; i++) {
        const element = elements[i];
        const tileImgId = 'single-tile-id-' + i;

        const imgDiv = createElement('div', tileImgId, 'single-tile-img-div', popUpTiles);
        imgDiv.classList.add(element.tileType);

        const img = createElement('img', null, 'tile', imgDiv);
        img.src = element.img_src;

        if (i === selected) {
          imgDiv.classList.add('selected');
        }

        // hide tiles if not of selected type
        if (selectedType !== element.tileType) {
          imgDiv.classList.add('hide');
        }

        imgDiv.addEventListener('click', function () {
          self._controls[title].chooseTile(i);
          self._callGCH(title);
        });
      }

      const popUpContentWrapper = createElement('div', 'pop-up-content-wrapper', 'pop-up-content-wrapper', popUpWrapper);
      const popUpContent = createElement('div', 'pop-up-content', 'pop-up-content', popUpContentWrapper);

      // pop up nav
      const popUpNav = createElement('div', 'pop-up-nav', 'pop-up-nav', popUpContent);
      const leftNav = createElement('div', 'pop-up-nav-left', 'pop-up-nav-left', popUpNav);
      const leftNavIcon = createElement('img', null, 'pop-up-nav-icon', leftNav);
      const leftNavText = createElement('div', 'pop-up-nav-text', 'pop-up-nav-text', leftNav);
      leftNavText.innerHTML = 'Choose Tile';
      leftNavIcon.src = pointFinger;
      const rightNav = createElement('div', 'pop-up-nav-right', 'pop-up-nav-right', popUpNav);
      rightNav.innerHTML = `<img src="${closeSvg}"/>`;

      const popUpContentFlex = createElement('div', 'pop-up-content-flex', 'pop-up-content-flex', popUpContent);

      // left content
      const popUpContentLeft = createElement('div', 'pop-up-content-left', 'pop-up-content-left', popUpContentFlex);
      const leftTitle = createElement('div', 'pop-up-content-left-title', 'pop-up-content-left-title', popUpContentLeft);
      const leftDimensions = createElement('div', 'pop-up-content-left-dimesions', 'pop-up-content-left-dimensions', popUpContentLeft);
      const priceWrapper = createElement('div', 'pop-up-content-price-wrapper', 'pop-up-content-price-wrapper', popUpContentLeft);
      const valute = createElement('div', 'pop-up-content-price-valute', 'pop-up-content-price-valute', priceWrapper);
      const priceWrapper2 = createElement('div', null, 'pop-up-content-price-wrapper-2', priceWrapper);
      const price = createElement('div', 'pop-up-content-price-price', 'pop-up-content-price-price', priceWrapper2);
      const areaName = createElement('div', 'pop-up-content-price-area', 'pop-up-content-price-area', priceWrapper2);
      const priceSpecColorWrapper = createElement('div', 'pop-up-content-spec-price-wrapper', 'pop-up-content-spec-price-wrapper', popUpContentLeft);
      priceSpecColorWrapper.innerHTML = selected === 0 ? config.specColorsPrice : '';
      const leftTileDescription = createElement('div', 'pop-up-content-left-description', 'pop-up-content-left-description', popUpContentLeft);
      leftTitle.innerHTML = elements[selected].title;
      leftDimensions.innerHTML = elements[selected].dimensions(units);
      leftTileDescription.innerHTML = elements[selected].desc;

      // right content
      const popUpContentRight = createElement('div', 'pop-up-content-right', 'pop-up-content-right', popUpContentFlex);
      valute.innerHTML = 'Standard Colors:&nbsp';
      price.innerHTML = `${elements[selected].price}`;
      areaName.innerHTML = `${elements[selected].priceUnit}`;

      // bottom content
      const popUpContentBackgroundImage = createElement('img', '', 'pop-up-content-bg-image', popUpContentRight);
      const popUpContentButton = createElement('div', 'pop-up-content-button', 'pop-up-content-button', popUpContentWrapper);
      popUpContentBackgroundImage.src = elements[selected].bg_img;
      popUpContentButton.innerHTML = 'Select Tile';

      // add controls
      this._controls[title] = {
        container: container,
        control: controlValue,
        popUpOpen: false,
        optionSelected: null, // this option is preselected, not confirmed
        getValue: function () {
          return this.control;
        },
        setValue: function (value) {
          setSelectedValue(value);
        },
        setTileType: function (tileType, tileIndex) {
          setShownTileType(tileType, tileIndex);
        },
        togglePopUp: function () {
          this.popUpOpen = !this.popUpOpen;
          if (this.popUpOpen) {
            popUp.classList.add('shown');
            callbackPopUpShown && callbackPopUpShown(true);
          } else {
            popUp.classList.remove('shown');
            callbackPopUpShown && callbackPopUpShown(false);
          }
        },
        chooseTile: function (tileIndex) {
          preSelectTile(tileIndex);
        }
      };

      const preSelectTile = (tileIndex) => {
        // remove sleected class for all elements
        const pointerElements = popUpTiles.querySelectorAll('.single-tile-img-div');
        for (let i = 0; i < pointerElements.length; i++) {
          pointerElements[i].classList.remove('selected');
        }

        // select tile
        const pointerID = 'single-tile-id-' + tileIndex;
        const selected = document.getElementById(pointerID);
        selected.classList.add('selected');

        // change text
        leftTitle.innerHTML = elements[tileIndex].title;
        price.innerHTML = elements[tileIndex].price;
        areaName.innerHTML = elements[tileIndex].priceUnit;
        priceSpecColorWrapper.innerHTML = tileIndex === 0 ? config.specColorsPrice : '';
        valute.innerHTML = tileIndex === 0 ? `${config.standardColorsPrice}:&nbsp` : '$';
        leftDimensions.innerHTML = elements[tileIndex].dimensions(units);
        leftTileDescription.innerHTML = elements[tileIndex].desc;
        popUpContentBackgroundImage.src = elements[tileIndex].bg_img;

        popUpContentWrapper.scrollTop = 0;
        self._controls[title].optionSelected = tileIndex;
      };

      const setSelectedValue = (value) => {
        const oldValue = +self._controls[title].control;
        if (oldValue === +value) {
          return false;
        }

        self._controls[title].control = +value;
        imgSelector.src = elements[value].img_src;
        if (callback) {
          callback(self._controls[title].control);
        }
      };

      const setShownTileType = (tileType, tileIndex = 0) => {
        const controlElementIndex = +self._controls[title].control;

        // nothing changed just return true
        if (controlElementIndex === tileType) {
          return true;
        }

        const proElements = popUpTiles.querySelectorAll('.pro');
        const homeElements = popUpTiles.querySelectorAll('.home');
        const selectedNewIndex = tileIndex;
        if (tileType === 'pro') {
          Object.keys(proElements).map((e) => proElements[e].classList.remove('hide'));
          Object.keys(homeElements).map((e) => homeElements[e].classList.add('hide'));
          // find index & set new selected tile
          // elements.some(e => {
          //   if (e.tileType === 'pro') {
          //     selectedNewIndex = e.id;
          //     return true;
          //   }
          //   return false;
          // });
        } else if (tileType === 'home') {
          Object.keys(proElements).map((e) => proElements[e].classList.add('hide'));
          Object.keys(homeElements).map((e) => homeElements[e].classList.remove('hide'));
          // elements.some(e => {
          //   if (e.tileType === 'home') {
          //     selectedNewIndex = e.id;
          //     return true;
          //   }
          //   return false;
          // });
        }
        preSelectTile(selectedNewIndex);
        setSelectedValue(selectedNewIndex);
      };

      imgSelector.addEventListener('click', function () {
        self._controls[title].togglePopUp();
        self._callGCH(title);
      });

      rightNav.addEventListener('click', function () {
        self._controls[title].togglePopUp();
        self._callGCH(title);
      });

      popUpContentButton.addEventListener('click', function () {
        if (self._controls[title].control !== self._controls[title].optionSelected && self._controls[title].optionSelected !== null) {
          setSelectedValue(self._controls[title].optionSelected);
        }
        self._controls[title].togglePopUp();
        self._callGCH(title);
      });

      popUp.addEventListener('click', function (e) {
        if (self._controls[title].popUpOpen && e.target.id === 'pop-up') {
          self._controls[title].togglePopUp();
        }
      });

      return this;
    },

    bindSingleTileSelector: function (title, value, object) {
      return this.addSingleTileSelector(title, value, (value) => {
        object[title] = value;
      });
    },

    addColorSelector: function (title, callback, selected = 0, palette, classPrefix = '') {
      const self = this;
      const colorId = selected;
      const selectedColor = palette[selected];
      const activePalette = [...palette];
      const container = this._createContainer();
      const selector = createElement('div', null, classPrefix + 'single-tile-color-selector', container);
      const menuColorTileSelectorWrapper = createElement('div', null, classPrefix + 'single-tile-color-selector-wrapper', selector);
      const colorSelectorBox = createElement('div', null, classPrefix + 'single-tile-color', menuColorTileSelectorWrapper);
      colorSelectorBox.style.backgroundColor = selectedColor;
      const textureSelector = createElement('img', null, classPrefix + 'single-tile-texture', menuColorTileSelectorWrapper);
      textureSelector.style.display = 'none';
      textureSelector.src = '';

      // create side-bar
      const sideBar = createElement('div', null, classPrefix + 'color-side-bar', container);

      // tiles
      const colorTiles = createElement('div', null, classPrefix + 'side-bar-color-tiles', sideBar);
      for (let i = 0; i < palette.length; i++) {
        const color = palette[i];
        const colorDiv = createElement('div', null, classPrefix + 'single-tile-color-div', colorTiles);
        colorDiv.style.backgroundColor = color;

        const colorName = self.findColorNameFromColorPalette(color).name.toUpperCase();
        const colorDivText = createElement('div', null, classPrefix + 'single-tile-color-div-text', colorTiles);
        colorDivText.innerHTML = colorName;

        colorDiv.addEventListener('click', function () {
          self._controls[title].chooseColor(i);
          self._callGCH(title);
        });
      }

      // add controls
      this._controls[title] = {
        container: container,
        control: selectedColor,
        palette: activePalette,
        colorId: colorId,
        sideBarOpen: false,
        getValue: function () {
          return this.control;
        },
        setValue: function (value) {
          const colorIndex = this.palette.indexOf(value);
          setSelectedValue(colorIndex);
        },
        toggleSideBar: function (hide = false) {
          if (hide) {
            this.sideBarOpen = false;
            sideBar.classList.remove('shown');
          } else {
            this.sideBarOpen = !this.sideBarOpen;
            if (this.sideBarOpen) {
              sideBar.classList.add('shown');
            } else {
              sideBar.classList.remove('shown');
            }
          }
        },
        chooseColor: function (tileIndex) {
          setSelectedValue(tileIndex);
        },
        changeColorPalette: function (palette, textures = false, mapColorsToPattern = []) {
          this.palette = palette;
          if (!textures) {
            changeColors(palette);
            setSelectedValue(0);
          } else {
            changeTextures(palette, mapColorsToPattern);
            setSelectedPattern(0, mapColorsToPattern[0]);
          }
        }
      };

      const changeColors = (palette) => {
        textureSelector.style.display = 'none';
        colorSelectorBox.style.display = 'block';

        // remove all child elements and its event handlers
        while (colorTiles.firstChild) {
          colorTiles.removeChild(colorTiles.firstChild);
        }
        for (let i = 0; i < palette.length; i++) {
          const color = palette[i];
          const colorDiv = createElement('div', null, classPrefix + 'single-tile-color-div', colorTiles);
          colorDiv.style.backgroundColor = color;

          const colorName = self.findColorNameFromColorPalette(color).name.toUpperCase();
          const colorDivText = createElement('div', null, classPrefix + 'single-tile-color-div-text', colorTiles);
          colorDivText.innerHTML = colorName;

          colorDiv.addEventListener('click', function () {
            self._controls[title].chooseColor(i);
            self._callGCH(title);
          });
        }

        const qsMain = container.parentElement.parentElement;
        const colorNameTitle = qsMain.getElementsByClassName('single-tile-control-color-name-title')[0];
        colorNameTitle.innerHTML = self.findColorNameFromColorPalette(palette[0]).name;
      };

      const setSelectedValue = (value) => {
        self._controls[title].colorId = +value;
        self._controls[title].control = self._controls[title].palette[value];
        colorSelectorBox.style.backgroundColor = self._controls[title].palette[value];

        const qsMain = container.parentElement.parentElement;
        const colorNameTitle = qsMain.getElementsByClassName('single-tile-control-color-name-title')[0];
        colorNameTitle.innerHTML = self.findColorNameFromColorPalette(self._controls[title].palette[value]).name;

        const { red, green, blue } = hexToRgb(self._controls[title].palette[value]);
        if ((red * 0.299 + green * 0.587 + blue * 0.114) > 186) {
          colorNameTitle.style.color = '#000000';
        } else colorNameTitle.style.color = '#ffffff';

        if (callback) {
          callback(self._controls[title].control);
        }
        self._controls[title].toggleSideBar(true);
      };

      function hexToRgb (hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
          ? {
              red: parseInt(result[1], 16),
              green: parseInt(result[2], 16),
              blue: parseInt(result[3], 16)
            }
          : null;
      }

      const changeTextures = (textures, textureColors) => {
        // set visible img texture
        textureSelector.style.display = 'block';
        colorSelectorBox.style.display = 'none';

        const qsMain = container.parentElement.parentElement;
        const colorNameTitle = qsMain.getElementsByClassName('single-tile-control-color-name-title')[0];
        colorNameTitle.innerHTML = self.findColorNameFromColorPalette(textureColors[0]).name;

        // remove all child elements and its event handlers
        while (colorTiles.firstChild) {
          colorTiles.removeChild(colorTiles.firstChild);
        }

        for (let i = 0; i < textures.length; i++) {
          const src = textures[i];
          const texture = createElement('img', null, classPrefix + 'single-tile-color-div', colorTiles);
          texture.src = src;

          const colorName = self.findColorNameFromColorPalette(textureColors[i]).name.toUpperCase();
          const colorDivText = createElement('div', null, classPrefix + 'single-tile-color-div-text', colorTiles);
          colorDivText.innerHTML = colorName;

          texture.addEventListener('click', function () {
            setSelectedPattern(i, textureColors[i]);
            self._callGCH(title);
          });
        }
      };

      const setSelectedPattern = (value, color) => {
        self._controls[title].colorId = +value;
        self._controls[title].control = self._controls[title].palette[value];
        textureSelector.src = self._controls[title].palette[value];
        const qsMain = container.parentElement.parentElement;
        const colorNameTitle = qsMain.getElementsByClassName('single-tile-control-color-name-title')[0];
        colorNameTitle.innerHTML = self.findColorNameFromColorPalette(color).name;
        colorNameTitle.style.color = '#ffffff';

        if (callback) {
          callback(value);
        }
        self._controls[title].toggleSideBar(true);
      };

      colorSelectorBox.addEventListener('click', function () {
        self._controls[title].toggleSideBar();
        self._callGCH(title);
      });

      textureSelector.addEventListener('click', function () {
        self._controls[title].toggleSideBar();
        self._callGCH(title);
      });

      return this;
    },

    bindSingleTileColorSelector: function (title, value, object) {
      return this.addColorSelector(title, value, (value) => {
        object[title] = value;
      });
    },

    arrowControls: function (title, callback) {
      // const self = this;
      const container = this._createContainer();

      // left arrow
      const left = createElement('div', null, 'left-arrow-wrapper', container);
      const right = createElement('div', null, 'right-arrow-wrapper', container);
      const up = createElement('div', null, 'up-arrow-wrapper', container);
      const down = createElement('div', null, 'down-arrow-wrapper', container);

      const leftArrow = createElement('div', null, 'left-arrow', left);
      const rightArrow = createElement('div', null, 'right-arrow', right);
      const upArrow = createElement('div', null, 'up-arrow', up);
      const downArrow = createElement('div', null, 'down-arrow', down);

      leftArrow.classList.add('move-pattern-arrow');
      rightArrow.classList.add('move-pattern-arrow');
      upArrow.classList.add('move-pattern-arrow');
      downArrow.classList.add('move-pattern-arrow');

      left.addEventListener('click', function () {
        if (callback) {
          returnValue('left');
        }
      });
      right.addEventListener('click', function () {
        if (callback) {
          returnValue('right');
        }
      });
      up.addEventListener('click', function () {
        if (callback) {
          returnValue('up');
        }
      });
      down.addEventListener('click', function () {
        if (callback) {
          returnValue('down');
        }
      });

      // add controls
      this._controls[title] = {
        container: container,
        control: null
      };

      const returnValue = (value) => {
        if (callback) {
          callback(value);
        }
      };

      return this;
    },

    bindArrowControls: function (title, value, object) {
      return this.arrowControls(title, value, (value) => {
        object[title] = value;
      });
    },

    addTextDesriptionForPanel: function (className, parentElement, description) {
      const el = parentElement;
      const holder = el.querySelector('.qs_main');
      const textDiv = document.createElement('div');
      textDiv.className = className;
      textDiv.innerHTML = description;
      holder.prepend(textDiv);
    },

    /**
     * Adds an existing HTML Element to the panel.
     * @param title {String} The title of the control.
     * @param element {HTMLElement} The element to add.
     * @returns {module:QuickSettings}
     */
    addElement: function (title, element) {
      const container = this._createContainer();
      const label = createLabel('<b>' + title + '</b>', container);

      container.appendChild(element);

      this._controls[title] = {
        container: container,
        label: label
      };
      return this;
    }
  };

  if (typeof exports === 'object' && typeof module === 'object') {
    module.exports = QuickSettings;
  } else if (typeof define === 'function' && define.amd) { // eslint-disable-line
    define(QuickSettings); // eslint-disable-line
  } else {
    window.QuickSettings = QuickSettings;
  }
}());
